import UriTemplate from 'uri-templates';
import {halClient} from "../hal";
import {context} from "../constants/context";
import {BBModel} from "../bb_model";
import {Collection} from "../collections/base";

const adminDay = {
    query(prms) {
        let url = '';
        if (prms.url) {
            ({url} = prms);
        }
        const href = url + `/api/${context.apiVersion}/{company_id}/day_data{?month,week,date,edate,event_id,service_id}`;

        const uri = new UriTemplate(href).fillFromObject(prms || {});
        return new Promise((resolve, reject) => {
            halClient.$get(uri, {}).then((found) => {
                    if (found.items) {
                        const mdays = [];
                        // it has multiple days of data
                        for (const item of Array.from(found.items)) {
                            halClient.$get(item.uri).then((data) => {
                                const days = [];
                                for (const i of Array.from(data.days)) {
                                    if (i.type === prms.item) {
                                        days.push(new BBModel.Day(i));
                                    }
                                }
                                const dcol = new Collection.Day(data, days, {});
                                return mdays.push(dcol);
                            });
                        }
                        return resolve(mdays);
                    }
                }
                , (err) => {
                    return reject(err);
                }
            );

        });
    }
};


export {
    adminDay
}
